<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <button *ngIf="selectedOuting" mat-raised-button class="pull-right"
                (click)="addIteration()">
                Add <mat-icon>add</mat-icon>
            </button>
        </mat-card-header>
        <mat-card-content>
            <mat-progress-bar mode="indeterminate" *ngIf="isOutingIterationsLoading"></mat-progress-bar>
            <gt-table *ngIf="true" [loading]="isOutingIterationsLoading" [defaultPageSize]="10"
                [updateFilterEvent]="updateFilterEvent" [filter]="iterationFilter" [data]="outingIterations"
                (filterChanged)="getOutingIterations()" (filterReset)="resetIterationFilter()">
            </gt-table>
            <table mat-table [dataSource]="outingIterations">
                <ng-container matColumnDef="courseName">
                    <th mat-header-cell *matHeaderCellDef>Course Name</th>
                    <td mat-cell *matCellDef="let iteration">
                        <a
                            [routerLink]="['../iteration', 'details', iteration.id]">{{iteration.courseName}}</a>&nbsp;
                    </td>
                </ng-container>
                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef>Start Date</th>
                    <td mat-cell *matCellDef="let iteration"> {{iteration.startDate | date: 'mediumDate'}} </td>
                </ng-container>
                <ng-container matColumnDef="cost">
                    <th mat-header-cell *matHeaderCellDef>Cost</th>
                    <td mat-cell *matCellDef="let iteration">${{iteration.cost}} </td>
                </ng-container>
                <ng-container matColumnDef="registrationCode">
                    <th mat-header-cell *matHeaderCellDef>Registration Code</th>
                    <td mat-cell *matCellDef="let iteration"> {{iteration.registrationCode}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let iteration">
                        <button mat-stroked-button [routerLink]="['../iteration', 'edit', iteration.id]">Edit <mat-icon>edit</mat-icon></button>&nbsp;
                        <button mat-stroked-button color="warn" (click)="deleteIteration(iteration)">Delete
                            <mat-icon>delete</mat-icon></button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let outing; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>